var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFileText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5703_16556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.832 7.50033H15.4154L10.832 2.91699V7.50033ZM4.9987 1.66699H11.6654L16.6654 6.66699V16.667C16.6654 17.109 16.4898 17.5329 16.1772 17.8455C15.8646 18.1581 15.4407 18.3337 14.9987 18.3337H4.9987C4.55667 18.3337 4.13275 18.1581 3.82019 17.8455C3.50763 17.5329 3.33203 17.109 3.33203 16.667V3.33366C3.33203 2.40866 4.0737 1.66699 4.9987 1.66699ZM12.4987 15.0003V13.3337H4.9987V15.0003H12.4987ZM14.9987 11.667V10.0003H4.9987V11.667H14.9987Z",
    fill: "#02006D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5703_16556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileText);
export default __webpack_public_path__ + "static/media/IconFileText.96397e91.svg";
export { ForwardRef as ReactComponent };